import React from 'react';
import { CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { plans } from '../data/content';
const finalPlans = plans;
export function FinalCta() {
  return <section className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="cierre-title" data-id="element-78" data-mp="15dly59p3rgyf">
      <div className="mx-auto max-w-5xl" data-id="element-79" data-mp="1jcd58c5js2d2">
        <h2 id="cierre-title" className="sr-only" data-id="element-80" data-mp="1jb22mfnu90nj">
          Última oportunidad al precio de lanzamiento
        </h2>

        <CountdownTimer heading="⏰ El precio cierra en:" data-id="element-81" data-mp="1t2ydysexqn9p" />

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-82" data-mp="1t2euh79mzqtk">
          {finalPlans.map(plan => <article key={plan.id} className={`flex flex-col rounded-3xl border p-6 sm:p-8 ${plan.featured ? 'border-gold bg-surface shadow-gold' : 'border-line bg-surface'}`} data-id="element-83" data-mp="1o4n26c52y2ou">
              <h3 className="text-lg font-extrabold leading-tight tracking-tight text-white sm:text-xl" data-id="element-84" data-mp="n75mjssvwf3n">
                🏋️ {plan.name}
              </h3>
              <p className="mt-2 text-sm text-neutral-400" data-id="element-85" data-mp="x38zzut6s05w">{plan.includes}</p>
              <div className="mt-5 flex flex-wrap items-baseline gap-3" data-id="element-86" data-mp="x64uta9qm8q4">
                <span className="text-base text-neutral-600 line-through" data-id="element-87" data-mp="1246i67e74u7e">
                  {plan.oldPrice}
                </span>
                <span className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-88" data-mp="1b3jquxuhxer2">
                  {plan.price}
                </span>
              </div>
              <div className="mt-6 flex-1" data-id="element-89" data-mp="1fv1q9hgvf79x" />
              <CtaButton href={plan.checkoutUrl} trackingLabel={plan.name} variant={plan.featured ? 'primary' : 'outline'} data-id="element-90" data-mp="1ktw8ah70krsz">
                {plan.cta}
              </CtaButton>
            </article>)}
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs font-medium text-neutral-500" data-id="element-91" data-mp="3quffrvc4xuus">
          <li className="inline-flex items-center gap-1.5" data-id="element-92" data-mp="3lwndc7dv6qcc">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-93" data-mp="3hl576c54cc3" />
            Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-94" data-mp="3uwiucsu3pfka">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-95" data-mp="3uuze328g34ii" />
            Acceso en 5 minutos
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-96" data-mp="dhvhmoqcpfq7">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-97" data-mp="8fwftja9eqvd" />
            Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-1.5" data-id="element-98" data-mp="mfxi9366a6cy">
            <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-99" data-mp="iec5dhtn1s2r" />
            Mercado Pago | Tarjeta | Transferencia
          </li>
        </ul>
      </div>
    </section>;
}